import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";
import _includes from "lodash/includes";
//
import { goToScreen, hideModal, goToBack } from "../modules/modal";
import { reportImageAction } from "../modules/flags";
import { clearUserMessagesAction } from "../modules/auth";
import Root from "../components/Root";
import { getUnread, isPremiumIn } from "../selectors";

// @connect
const state = (state) => {
  const { ajax, booking, modal, models, flags } = state;
  const model = models.entities[models.active] || null;

  let isLoading = ajax.isFetching.length > 0;

  if (modal.screen === "book") {
    isLoading = booking.isFetching;
  } else if (modal.screen === "countries") {
    isLoading = false;
  }

  return {
    isLoading,
    loadingTitle: ajax.pendingTitle,
    loadingMessage: ajax.pendingMessage,
    error: ajax.message,
    success: ajax.success,
    modal,
    model,
    isPremium: isPremiumIn(state),
    imagesReported: flags.images,
    modelsVisible: models.visible,
    unread: getUnread(state),
  };
};

const actions = (dispatch) =>
  bindActions(
    {
      hideModal,
      goBack: goToBack,
      reportImage: reportImageAction,
      goTo: goToScreen,
      clearUserMessages: clearUserMessagesAction,
    },
    dispatch
  );

export default connect(state, actions)(Root);
